import React from 'react'
import ReactDOM from 'react-dom'
import { PageBase } from 'frontend/common-imports'
import Map from 'frontend/pages/locations/map'

export default class LocationsPage extends PageBase {
  static render () {
    ReactDOM.render(<Map />, document.getElementById('locations_react'))
  }
}

LocationsPage.init()
